import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import * as Yup from 'yup';


import { format } from 'date-fns';


import * as S from './styles';
import { Visibility, VisibilityOff } from '@material-ui/icons';
import { IconButton } from '@material-ui/core';
import { t, parseDateString } from '~/helpers';
import { closeDialog } from '~/store/modules/dialog/actions';
import { Input, DateTime, InputText, Select, Autocomplete } from '~/components/Form';
import { SelectComplete } from '~/componentslocal';
import { isEmpty, isNull } from 'lodash';

import { updatePleitoPosto } from '~/store/modules/pleitoposto/actions';

export default function FormUpdate({ create, data, close, ...props }) {
  const dispatch = useDispatch();
  const reference = useRef(null)
  const redux = useSelector((state) => state.pleitoposto);
  const [initials, setInitials] = useState(data)
  const [params, setParams] = useState({})



  const [dataHoraEnvioVisibility, setDataHoraEnvioVisibility] = useState(false)
  const [dataHoraAutorizadoNFVisibility, setDataHoraAutorizadoNFVisibility] = useState(false)
  const [dataHoraPagamentoNFVisiblity, setDataHoraPagamentoNFVisibility] = useState(false)
  const [dataHoraCanceladoVisibility, setDataHoraCanceladoVisibility] = useState(false)



  useEffect(() => {

    if (!isNull(initials.plei_datahora_envio)) {
      setDataHoraEnvioVisibility(true)
    }

    if (!isNull(initials.plei_datahora_autorizado_nf)) {
      setDataHoraAutorizadoNFVisibility(true)
    }

    if (!isNull(initials.plei_datahora_pagamento_nota_fiscal)) {
      setDataHoraPagamentoNFVisibility(true)
    }

    if (!isNull(initials.plei_datahora_cancelado)) {
      setDataHoraCanceladoVisibility(true)
    }

  }, [initials])


  const handleToggleVisibilityDataHoraEnvio = useCallback(() => {
    setDataHoraEnvioVisibility(state => !state)
  }, [])

  const handleToggleVisibilityDataHoraAutorizadoNF = useCallback(() => {
    setDataHoraAutorizadoNFVisibility(state => !state)
  }, [])

  const handleToggleVisibilityDataHoraPagamentoNF = useCallback(() => {
    setDataHoraPagamentoNFVisibility(state => !state)
  }, [])

  const handleToggleVisibilityDataHoraCancelado = useCallback(() => {
    setDataHoraCanceladoVisibility(state => !state)
  }, [])

  const handleTestValorPleito = useCallback((value) => {
    const regex1 = /^((\d+\,\d+){1})$/;
    const regex2 = /^(\d+)$/;
    const regex3 = /^((\d+\.\d+){1})$/;

    if (regex1.test(value) || regex2.test(value) || regex3.test(value) || isEmpty(value)) {
      return true
    }
    return false
  }, [])

  const handleSubmit = useCallback(async function (params) {
    try {

      const schema = Yup.object().shape({
        plei_datahora_pleito: Yup.date()
          .transform((_, value) => parseDateString(value))
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .required(t('s.geral.validacao.campoobrigatorio')),
        poco_codigo: Yup.string()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .required(t('s.geral.validacao.campoobrigatorio')),
        plsi_codigo: Yup.number()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .required(t('s.geral.validacao.campoobrigatorio')),
        orga_codigo: Yup.number()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .required(t('s.geral.validacao.campoobrigatorio')),
        plei_numero_laudo: Yup.string()
          .typeError(t('s.geral.validacao.campoobrigatorio')),
        plei_valor_pleito: Yup.string()
          .test('teste valor pleito', 'Valor Inválido', value => handleTestValorPleito(value))
          .typeError(t('s.geral.validacao.campoobrigatorio')),
        plei_datahora_envio: dataHoraEnvioVisibility ?
          Yup.date()
            .transform((_, value) => parseDateString(value))
          :
          Yup.string()
            .nullable(),
        plei_status: Yup.string()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .required(t('s.geral.validacao.campoobrigatorio')),
        plei_datahora_autorizado_nf: dataHoraAutorizadoNFVisibility ?
          Yup.date()
            .transform((_, value) => parseDateString(value))
            .typeError(t('s.geral.validacao.campoobrigatorio'))
          :
          Yup.string()
            .nullable(),
        plei_numero_pedido: Yup.string()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .nullable(),
        plei_nota_fiscal_servico: Yup.string()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .nullable(),
        plei_nota_fiscal_produto: Yup.string()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .nullable(),
        plei_datahora_pagamento_nota_fiscal: dataHoraPagamentoNFVisiblity ?
          Yup.date()
            .transform((_, value) => parseDateString(value))
            .typeError(t('s.geral.validacao.campoobrigatorio'))
          :
          Yup.string()
            .nullable(),
        plei_datahora_cancelado: dataHoraCanceladoVisibility ?
          Yup.date()
            .transform((_, value) => parseDateString(value))
            .typeError(t('s.geral.validacao.campoobrigatorio'))
          :
          Yup.string()
            .nullable(),
        plei_observacao: Yup.string()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .nullable()
      })
      await schema.validate(params, {
        abortEarly: false,
      })



      let obj = {
        ...params,
        plei_codigo: params.plei_codigo,
        plei_datahora_autorizado_nf: dataHoraAutorizadoNFVisibility ? params.plei_datahora_autorizado_nf : undefined,
        plei_datahora_cancelado: dataHoraCanceladoVisibility ? params.plei_datahora_cancelado : undefined,
        plei_datahora_envio: dataHoraEnvioVisibility ? params.plei_datahora_envio : undefined,
        plei_datahora_pagamento_nota_fiscal: dataHoraPagamentoNFVisiblity ? params.plei_datahora_pagamento_nota_fiscal : undefined,
        plei_valor_pleito: isEmpty(params.plei_valor_pleito) ? 0.00 : Number(params.plei_valor_pleito.replace(',', '.')),
        plei_tipo: 'P'
      }





      dispatch(updatePleitoPosto(obj, redux.params))

      reference.current.setErrors({})

      close();

    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    }
  }, [dataHoraAutorizadoNFVisibility, dataHoraCanceladoVisibility, dataHoraEnvioVisibility, dataHoraPagamentoNFVisiblity])



  useEffect(() => {
    if (props.sending) {
      reference.current.submitForm();
    }
  }, [props, reference])

  const formatValorPleito = useCallback((valor) => {
    return String(valor).replace('.', ',')
  }, [])


  return (
    <>
      <S.FormWrapper ref={reference} initialData={{
        ...initials,
        poco_codigo: initials.poco_codigo_new ? initials.poco_codigo_new : initials.poco_codigo,
        plei_datahora_pleito: initials.plei_datahora_pleito_new ? undefined : new Date(initials.plei_datahora_pleito),
        plei_datahora_envio: initials.plei_datahora_envio_new ? undefined : isNull(initials.plei_datahora_envio) ? initials.plei_datahora_envio : new Date(initials.plei_datahora_envio),
        plei_datahora_autorizado_nf: initials.plei_datahora_autorizado_nf_new ? undefined : isNull(initials.plei_datahora_autorizado_nf) ? initials.plei_datahora_autorizado_nf : new Date(initials.plei_datahora_autorizado_nf),
        plei_datahora_pagamento_nota_fiscal: initials.plei_datahora_pagamento_nota_fiscal_new ? undefined : isNull(initials.plei_datahora_pagamento_nota_fiscal) ? initials.plei_datahora_pagamento_nota_fiscal : new Date(initials.plei_datahora_pagamento_nota_fiscal),
        plei_datahora_cancelado: initials.plei_datahora_cancelado_new ? undefined : isNull(initials.plei_datahora_cancelado) ? initials.plei_datahora_cancelado : new Date(initials.plei_datahora_cancelado),
        plei_valor_pleito: formatValorPleito(initials.plei_valor_pleito),
      }} onSubmit={handleSubmit}>
        <Input name="plei_codigo" label="Número do Pleito:" disabled />
        <DateTime name="plei_datahora_pleito" label="Data hora pleito" time
          getValue={(value) => setInitials(state => ({ ...state, plei_datahora_pleito_new: value }))} />
        <SelectComplete
          name="poco_codigo"
          unique="poco_codigo"
          label="poco_desc_abrev"
          title="Posto"
          url="pleitopostosporusuario"
          getValue={(value) => setInitials((state) => ({ ...state, poco_codigo_new: value.poco_codigo }))}
        />
        <SelectComplete
          name="plsi_codigo"
          unique="plsi_codigo"
          label="plsi_descritivo"
          title="Situação"
          url="pleito/pleitosituacao"
          params={{
            wherefield: ['plsi_tipo'],
            valuewherefield: ['P'],
            typewherefield: ['EQUALS']
          }}

        />
        <Autocomplete
          name="orga_codigo"
          label="orga_nome"
          title="Órgão"
          url="orgaos"
          unique="orga_codigo"
        />
        <InputText name="plei_numero_laudo" label="Número do Laudo:" placeholder="" mask="********" />
        <InputText
          name="plei_valor_pleito"
          label="Valor do Pleito:"
          mask="dddddddd"
          placeholder=""
        />
        <S.ContainerEyer>
          {dataHoraEnvioVisibility ?
            <>
              <DateTime name="plei_datahora_envio"
                label="Data de envio do pleito:"
                time
                getValue={(value) => setInitials(state => ({ ...state, plei_datahora_envio_new: value }))}
              />

              <IconButton onClick={handleToggleVisibilityDataHoraEnvio}>
                <Visibility />
              </IconButton>
            </>
            :
            <>
              <Input name="plei_datahora_envio" label="Data de envio do pleito" value="00/00/0000 00:00" disabled />

              <IconButton onClick={handleToggleVisibilityDataHoraEnvio}>
                <VisibilityOff />
              </IconButton>
            </>}
        </S.ContainerEyer>
        <Select
          name="plei_status"
          label="Status"
          options={[
            { value: 'A', label: 'Aberto' },
            { value: 'C', label: 'Cancelado' },
            { value: 'F', label: 'Autorizado Nota Fiscal' },
            { value: 'P', label: 'Pago' },
          ]}

        />
        <S.ContainerEyer>
          {dataHoraAutorizadoNFVisibility ?
            <>
              <DateTime
                name="plei_datahora_autorizado_nf"
                label="Data autorização NF"
                time
                getValue={(value) => setInitials(state => ({ ...state, plei_datahora_autorizado_nf_new: value }))}
              />

              <IconButton onClick={handleToggleVisibilityDataHoraAutorizadoNF}>
                <Visibility />
              </IconButton>
            </>
            :
            <>
              <Input name="plei_datahora_autorizado_nf" label="Data autorização NF" value="00/00/0000 00:00" disabled />

              <IconButton onClick={handleToggleVisibilityDataHoraAutorizadoNF}>
                <VisibilityOff />
              </IconButton>
            </>}

        </S.ContainerEyer>

        <InputText name="plei_numero_pedido" label="Número do pedido:" placeholder="" mask="999999999" />
        <InputText name="plei_nota_fiscal_servico" label="Número NF Serviço:" placeholder="" mask="999999999" />
        <InputText name="plei_nota_fiscal_produto" label="Número NF Produto:" placeholder="" mask="999999999" />
        <S.ContainerEyer>
          {dataHoraPagamentoNFVisiblity ?
            <>
              <DateTime
                name="plei_datahora_pagamento_nota_fiscal"
                label="Data Pagamento NF"
                time
                getValue={(value) => setInitials(state => ({ ...state, plei_datahora_pagamento_nota_fiscal_new: value }))}
              />
              <IconButton onClick={handleToggleVisibilityDataHoraPagamentoNF}>
                <Visibility />
              </IconButton>
            </>

            :
            <>

              <Input name="plei_datahora_pagamento_nota_fiscal" label="Data Pagamento NF" value="00/00/0000 00:00" disabled />

              <IconButton onClick={handleToggleVisibilityDataHoraPagamentoNF}>
                <VisibilityOff />
              </IconButton>
            </>

          }
        </S.ContainerEyer>
        <S.ContainerEyer>
          {dataHoraCanceladoVisibility ?
            <>
              <DateTime name="plei_datahora_cancelado" label="Data Cancelamento" time
                getValue={(value) => setInitials(state => ({ ...state, plei_datahora_cancelado_new: value }))}
              />
              <IconButton onClick={handleToggleVisibilityDataHoraCancelado}>
                <Visibility />
              </IconButton>

            </>
            :
            <>

              <Input name="plei_datahora_cancelado" label="Data Cancelamento" value="00/00/0000 00:00" disabled />

              <IconButton onClick={handleToggleVisibilityDataHoraCancelado}>
                <VisibilityOff />
              </IconButton>
            </>
          }

        </S.ContainerEyer>
        <Input
          name="plei_observacao"
          label="Observação:"
          inputProps={{ maxLength: 500 }}
          multiline
          rows={5}
        />

      </S.FormWrapper>


    </>
  );
}

FormUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

FormUpdate.defaultProps = {
  data: {},
};
